import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const AddReportIcon = (props) => {
  const { themeName } = useContext(themeContext);
  return (
    <>
      {!props.active ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="32"
          viewBox="0 0 38 32"
          fill={ themeName != "light"?"rgb(255, 255, 255, 0.2)":"rgb(0, 0, 0, 0.4)"}
        >
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H34C36.2091 0 38 1.79086 38 4V32H0V4Z"
            fill={ themeName != "light"?"rgb(255, 255, 255, 0.2)":"rgb(0, 0, 0, 0.4)"}
          />
          <path d="M26 17H20V23H18V17H12V15H18V9H20V15H26V17Z" fill="#D7D7D7" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="32"
          viewBox="0 0 38 32"
          fill="none"
        >
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H34C36.2091 0 38 1.79086 38 4V32H0V4Z"
            fill="#0085FF"
          />
          <path d="M26 17H20V23H18V17H12V15H18V9H20V15H26V17Z" fill="white" />
        </svg>
      )}
    </>
  );
};

export default AddReportIcon;
